// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Dot16 from './Dot16';
import Dot20 from './Dot20';

type DotProps = {
    variation: '16' | '20';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Dot16,
    Dot20,
};

const Dot: FC<DotProps> = ({ variation, ...props }) => {
    const variationKey = `Dot${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Dot" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Dot;
